import { render, staticRenderFns } from "./GoalSnapshotView.vue?vue&type=template&id=57a50e78&"
import script from "./GoalSnapshotView.vue?vue&type=script&lang=ts&"
export * from "./GoalSnapshotView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports